
import React,{useState,useEffect} from "react";
import {
  Button,
  FormFieldSet,
  showToast,
  useFormHandler,
} from "../../../../../components";
import {fetchJobQuestions} from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
const QualifyingQuestions = ({jobPostId}) => {
  const [manualQuestions,setManualQuestions] = useState([])

  const initialData = {
    questionType: "aiGenerated",
  };

    useEffect(() => {
      const getJobQuestions = async () => {
        try {
          const response = await fetchJobQuestions({
            coll: "JobPosting",
            fil: {uiid:{type:"NONE",value:jobPostId}},
            ret:"questionIds",
            lim:null,
            pg:null,
            ref:"JobPostQuestion",
            extret:"uiid firstName role"
          });
          const items =response?.data?.data?.questionIds ? response.data.data.questionIds : [];
          setManualQuestions(items);
          console.log(response)
        } catch (err) {
          showToast("Failed to fetch", "error")
          console.error("Error fetching job smart insights details:", err);
        } 
      };
      
        getJobQuestions();
      
    }, []);
    
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialData, {});
  return (
    <div className="p-2">
      <h5 className="my-2">Qualifying Questions</h5>
      <FormFieldSet
        type="radio"
        noTitle
        options={[
          {
            label: "AI Generated Questions",
            value: "aiGenerated",
          },
          {
            label: "Manual Questions",
            value: "manualQuestions",
          },
        ]}
        value={formData.questionType}
        onChange={(event) => handleChange("questionType", event.target.value)}
        error={errors.questionType}
      />
      {formData.questionType === "aiGenerated" ? (
        [].map((question, key) => (
          <div>
            <p className="text-sm font-[600] my-2">
              {key + 1}.{question.question}
            </p>
            <FormFieldSet value={question.answer} noTitle placeholder="Enter your answer" size="sm" />
          </div>
        ))
      ) : (
        <div>
          <Button
            title={"Add Question"}
            variant="outlined"
            className="font-[600]"
          />
          {manualQuestions.map((question, key) => (
            <div key={question.uiid}>
              <div className="flex justify-between items-center">
                <p className="text-sm font-[600] my-2">
                  {key+1}.{question.question}
                </p>
                <div className="flex items-center ">
                  <Button
                    icon={"edit_square"}
                    variant="text"
                    type="icon"
                    size="sm"
                    color="black"
                  />
                  <Button
                    icon={"delete"}
                    variant="text"
                    type="icon"
                    size="sm"
                    color="black"
                  />
                </div>
              </div>
              <FormFieldSet value={question.answer} noTitle placeholder="Enter your answer" size="sm" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QualifyingQuestions;
